var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true}}],attrs:{"element-loading-background":"rgba(0, 0, 0, 0.8)"}})}
var staticRenderFns = []

export { render, staticRenderFns }